import { InputGroup, Label } from '@slal/ui/forms';
import { Controller, useFormContext } from '@slal/ui/react-hook-form/core';
import { NumberFormatValues, NumericFormat } from 'react-number-format';
import { CurrencyInput } from '../Form';
import { InputWrapper, SliderField, StyledRangeInput } from './styles';

interface SliderProps {
    name: string;
    min: number;
    max: number;
    label: string;
    unit?: string;
}

export const Slider = ({ name, min, max, label, unit }: SliderProps) => {
    const formContext = useFormContext();
    return (
        <SliderField label={label} errorFor={name}>
            <InputWrapper>
                <InputGroup>
                    {unit && <Label htmlFor={name}>{unit}</Label>}
                    <Controller
                        name={name}
                        control={formContext.control}
                        render={({ field: { onChange, value, onBlur } }) => (
                            <NumericFormat
                                name={name}
                                id={name}
                                aria-label={label}
                                customInput={CurrencyInput}
                                value={value}
                                valueIsNumericString
                                thousandSeparator
                                onValueChange={(v: NumberFormatValues) => {
                                    const newValue = v.value ? Number(v.value) : null;
                                    onChange(newValue);
                                }}
                                onBlur={() => onBlur()}
                                isAllowed={values => {
                                    const { formattedValue } = values;
                                    return !formattedValue.includes('-') && !formattedValue.includes('.');
                                }}
                            />
                        )}
                    />
                </InputGroup>

                <Controller
                    name={name}
                    control={formContext.control}
                    render={({ field }) => (
                        <StyledRangeInput
                            {...field}
                            id={name}
                            aria-label={label}
                            type="range"
                            min={min}
                            max={max}
                            fillPercentage={((field.value - min) / (max - min)) * 100}
                            onChange={e => {
                                const newValue = Number(e.target.value);
                                field.onChange(newValue);
                            }}
                        />
                    )}
                />
            </InputWrapper>
        </SliderField>
    );
};
